import { render } from "./Process.vue?vue&type=template&id=950c8956&scoped=true"
const script = {}

import "./Process.vue?vue&type=style&index=0&id=950c8956&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-950c8956"

export default script